import { useEffect, useState } from "react";
import { ImageOff, Loader2, RefreshCw } from "lucide-react";
import axios from "axios";
import { useAdmin } from "./AdminSession";

export const PrivateProductImage = ({ product, prefix = "product" }) => {
    const { api } = useAdmin();
    const [url, setUrl] = useState("");
    const [failed, setFailed] = useState(false);
    const [retry, setRetry] = useState(0);
    useEffect(() => {
        const controller = new AbortController(); let objectUrl;
        setUrl(""); setFailed(false);
        api.get(`/admin/products/${product.id}/image`, { responseType: "blob", signal: controller.signal }).then(({ data }) => {
            if (controller.signal.aborted) return;
            objectUrl = URL.createObjectURL(data); setUrl(objectUrl);
        }).catch((error) => { if (!axios.isCancel(error)) setFailed(true); });
        return () => { controller.abort(); if (objectUrl) URL.revokeObjectURL(objectUrl); };
    }, [api, product.id, product.image_version, retry]);
    if (failed) return <div className="product-image-status" data-testid={`${prefix}-image-error-${product.id}`}><ImageOff size={24} /><span>Image unavailable</span><button type="button" className="text-link" onClick={(event) => { event.preventDefault(); event.stopPropagation(); setRetry((value) => value + 1); }} data-testid={`${prefix}-image-retry-${product.id}`}><RefreshCw size={14} />Retry</button></div>;
    if (!url) return <div className="product-image-status" role="status" data-testid={`${prefix}-image-loading-${product.id}`}><Loader2 size={20} className="animate-spin" /><span className="sr-only">Loading product image</span></div>;
    return <img src={url} alt={product.name} data-testid={`${prefix}-image-${product.id}`} className="private-product-image" />;
};